import Exception from "core/exceptions/Exception";
import DefaultExceptionTypes from "core/exceptions/DefaultExceptionTypes";
import CustomersRepository from "@/core/customers/repositories/CustomersRepository";

export default class ImportCoreBankingCustomerUseCase {
  constructor(private readonly customersRepository: CustomersRepository) { }

  async execute(customer: unknown): Promise<string | undefined> {
    try {
      return await this.customersRepository.importCoreBankingCustomer(
        customer as unknown
      );
    } catch (e) {
      if ((e as Exception).type) {
        throw e;
      }

      const error = new Error("Core banking import failed") as Error &
        Exception<unknown, DefaultExceptionTypes>;
      error.type = DefaultExceptionTypes.UNKNOWN_ERROR;
      error.body = e;
      throw error;
    }
  }
}
